package link.erpango.quip.ui.ocr

import androidx.compose.runtime.Composable
import link.erpango.quip.domain.ocr.OcrError

/**
 * JS/Web image picking fallback — not implemented yet, so [isSupported] is false and the common
 * UI hides the "choose image" action instead of showing a failing button.
 */
actual object PlatformImagePicker : ImagePickerContract {
    actual override val isSupported: Boolean = false

    @Composable
    actual override fun rememberLauncher(
        onImagePicked: (ByteArray) -> Unit,
        onError: (OcrError) -> Unit,
    ): ImagePickerLauncher = ImagePickerLauncher {}
}
